import { render, staticRenderFns } from "./withdrawalbd.vue?vue&type=template&id=048f3e08&scoped=true"
import script from "./withdrawalbd.vue?vue&type=script&lang=js"
export * from "./withdrawalbd.vue?vue&type=script&lang=js"
import style0 from "./withdrawalbd.vue?vue&type=style&index=0&id=048f3e08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f3e08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048f3e08')) {
      api.createRecord('048f3e08', component.options)
    } else {
      api.reload('048f3e08', component.options)
    }
    module.hot.accept("./withdrawalbd.vue?vue&type=template&id=048f3e08&scoped=true", function () {
      api.rerender('048f3e08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/withdrawalbd.vue"
export default component.exports